import { LessonService, ContentService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';

import { ContentModuleTypes, ContentModals, EVENTS } from '../interfaces';

class AddContentModuleController {
    
    // @attributes
	public lessonId:string;
	public permissions:any;
	public portfolioPageId:string;
	public position;
	public type:string;
	public viewType:string;
	
	// @state
	public state$ = {
        'isMenuExpanded' : false,
        'isLoading' : false
    };
	
	
	// @ngInject
	constructor(
 		private ModalService,
		private $element,
		private $location		: ng.ILocationService,
 		private $log            : ng.ILogService,
		private lessonService   :  LessonService, 
		private contentService  :  ContentService,
		private observerService :  ObserverService
	){}
	
	public $onInit = () => {
		
		this.observerService.attach(this.setViewType, 'viewType');
		
		this.viewType = this.$location.search().view;
		
		if(this.type == null){
			if(this.lessonId?.length == 32){
				
				this.type = 'lesson';
				
			} else if (this.portfolioPageId?.length == 32){
				
				this.type = 'portfolioPage';
			
			} else if (this.$location.search().lessonType != null){
				this.type = 'lesson';
			} else { 
				
				this.type = 'portfolioPage';
				this.state$.isMenuExpanded = true;
			}
		}
	}
	
	public setViewType = (viewType) =>{
		this.viewType = viewType;
	}
	
	public toggleMenu = () => {
	    this.state$.isMenuExpanded = !this.state$.isMenuExpanded;
	}
	
	public launchModal = (modalComponentName, contentModuleType) => {
		
		let bindings:any = {
			contentModuleType: contentModuleType,
			position:this.position
		}
		
		bindings.type = this.type;
		
		if(this.type === 'lesson'){
			
			bindings.lessonId = this.lessonId
		
		} else if (this.type === 'portfolioPage'){
			
			bindings.portfolioPageId = this.portfolioPageId
		}
		
		this.ModalService.showModal({
			component: modalComponentName,
			bodyClass: 'angular-modal-service-active',
			bindings: bindings,
			preClose: (modal) => {
				modal.element.modal('hide');
			}
		})
		.then((modal) => {
			//it's a bootstrap element, use 'modal' to show it
			modal.element.modal('show');
			modal.close.then((result) => {});
		});
	}
	
	public addContentModuleType = (contentModuleType = ContentModuleTypes.TEXT) => {
		this.$log.log("addContentModuleType::clicked ", contentModuleType);

		this.state$.isMenuExpanded = false;
		
		switch(contentModuleType){
		    case ContentModuleTypes.BOOK:
		    	this.launchModal(ContentModals.ADD_BOOK, contentModuleType)
		    	break;
		    case ContentModuleTypes.IMAGE:
				this.launchModal('imageUploadModal', contentModuleType);
		    	break;
		    case ContentModuleTypes.LESSON: 
		    	this.launchModal('importLessonContentModal', contentModuleType);
		    	break; 
		    case ContentModuleTypes.VIDEO:
		        this.launchModal(ContentModals.ADD_VIDEO, contentModuleType);
		    	break;
		    case ContentModuleTypes.BUTTON:
		        this.launchModal(ContentModals.ADD_BUTTON, contentModuleType);
		    	break;
		    case ContentModuleTypes.EMBEDDED:
		        this.launchModal(ContentModals.IMPORT_CONTENT, contentModuleType);
		    	break;
	    	case ContentModuleTypes.FORM:
		        this.launchModal(ContentModals.ADD_FORM, contentModuleType);
		    	break;
		    default:
		    	var newContentModule = this.contentService.newContentModule( contentModuleType, this.position );
		    
		    	if( this.lessonId && this.lessonId.length === 32){
		    		this.observerService.notifyById( EVENTS.ADD_CONTENT, this.lessonId, newContentModule );
		    	} else if( this.portfolioPageId && this.portfolioPageId.length === 32) {
		    		this.observerService.notifyById( EVENTS.ADD_CONTENT, this.portfolioPageId, newContentModule );
		    	} else { 
		    		this.observerService.notify( EVENTS.ADD_CONTENT, newContentModule );
		    	}
		    	
		    	break;
		}
	}
}

class AddContentModule implements ng.IDirective {
	public restrict: string = 'E';
	public scope = {};

	public bindToController: any = {
		type:'@?',
		lessonId:'=?',
		permissions:'<?',
		portfolioPageId:'=?',
		position:'=',
		contentModule:'='
	};

	public controller = AddContentModuleController;
	public controllerAs = 'addContentModuleControl';

	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/add-content-module.html';

	public static Factory() {
		return () => new this();
	}
}

export { AddContentModule };
